import { render, staticRenderFns } from "./SubscribeForm.vue?vue&type=template&id=0939fc87&scoped=true"
import script from "./SubscribeForm.vue?vue&type=script&lang=js"
export * from "./SubscribeForm.vue?vue&type=script&lang=js"
import style0 from "./SubscribeForm.vue?vue&type=style&index=0&id=0939fc87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0939fc87",
  null
  
)

export default component.exports